<template>
    <div :class="b()">
        <div class="col-md-3" v-if="userIsSeller">
            <label :class="b('participation-filter')">
                Участвовал
                <input type="radio" value="participant" v-model="participationType">
            </label>
            <label :class="b('participation-filter')">
                Победил
                <input type="radio" value="winner" v-model="participationType">
            </label>
        </div>
        <div class="col-md-6 col-wrap-filter">
            <multiselect
                    v-model="buyingFilterType"
                    selectedLabel="Выбрано"
                    selectLabel="Нажмите для добавления"
                    deselectLabel="Нажмите для удаления"
                    track-by="name"
                    label="value"
                    placeholder="Вы можете отфильтровать закупки по пользовательским статусам"
                    :options="buyingFilter"
                    :searchable="false"
            ></multiselect>
        </div>
    </div>

</template>

<script>
    import Buying from "../services/BuyingService";
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import Multiselect from 'vue-multiselect'

    const COMPONENT_NAME = "seller-participation-filter";

    export default {
        name: COMPONENT_NAME,
        props: ['userIsSeller'],
        components: {
            'multiselect': Multiselect,
        },
        data() {
            return {
                participationType: 'participant',
                participationCookie: 'participation',
                buyingFilter: [],
                buyingFilterType: [],
                buyingFilterCookie: 'buyingFilter',
            };
        },
        mounted() {

            // Запрос фильтров
            this.getBuyingFilter();
        },
        methods: {
            async getBuyingFilter() {
                if(this.userIsSeller) {
                    this.participationType = this.$cookies.get(this.participationCookie) || 'participant';
                }
                try {
                    let response = await Buying.getBuyingUserFilter();
                    if (response.success) {
                        this.buyingFilter = response.data.buyingFilterStructure;

                        let cookiesFilter = this.$cookies.get(this.buyingFilterCookie);
                        if(cookiesFilter) {
                            this.buyingFilterType = this.buyingFilter.find(x => x.name === cookiesFilter);
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        },
        watch: {
            participationType: {
                handler() {

                    if (this.$cookies.get(this.participationCookie) != this.participationType) {
                        this.$cookies.set(this.participationCookie, this.participationType, {path: '/'});

                        this.$router.replace({
                            path: this.$route.path,
                            query: Object.assign({}, {
                                participation: this.participationType,
                                filter: this.buyingFilterType.name
                            })
                        }).catch(err => {
                        });

                        window.location.assign(this.$route.fullPath);
                    }
                }
            },
            buyingFilterType: {

                // TODO: Через жопу получается, позже подумать как улучшить
                handler() {
                    let param = null;
                    let redirectIfExist = !!this.$route.query.filter || false;
                    let buyingFilterCookie = this.$cookies.get(this.buyingFilterCookie);

                    // Если сбросили фильтр закупок
                    if(this.buyingFilterType == null && buyingFilterCookie) {
                        if(this.userIsSeller) {
                            param = {
                                participation: this.participationType,
                            };
                        }

                        this.$router.replace({
                            path: this.$route.path,
                            query: Object.assign({}, param)
                        }).catch(err => {
                        });

                        this.$cookies.remove(this.buyingFilterCookie, {path: '/'});
                        window.location.assign(this.$route.fullPath);
                    }else{
                        if(this.userIsSeller) {
                            param = {
                                participation: this.participationType,
                                filter: this.buyingFilterType.name
                            };
                        }else{
                            param = {
                                filter: this.buyingFilterType.name
                            };
                        }

                        this.$router.replace({
                            path: this.$route.path,
                            query: Object.assign({}, param)
                        }).catch(err => {
                        });

                        if (buyingFilterCookie != this.buyingFilterType.name) {
                            this.$cookies.set(this.buyingFilterCookie, this.buyingFilterType.name, {path: '/'});

                            window.location.assign(this.$route.fullPath);
                        }else{
                            if(!redirectIfExist) {
                                window.location.assign(this.$route.fullPath);
                            }
                        }
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .seller-participation-filter {
        display: flex;
        margin-bottom: 10px;

        &__participation-filter {
            padding: 5px;
        }

        .col-wrap-filter{
            z-index: 100;
        }
    }
</style>